import { MedplumClient } from "@medplum/core";
import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { joinReferenceString } from "@/utils/medplum";

/**
 * Loads encounter flowsheet QuestionnaireResponses for amend ParentVersionId diff membership.
 */
export async function fetchEncounterFlowsheetQuestionnaireResponsesById(
  medplum: MedplumClient,
  clientId: string,
  encounterId: string,
): Promise<Map<string, QuestionnaireResponse>> {
  const questionnaireResponses = await medplum.searchResources("QuestionnaireResponse", {
    encounter: joinReferenceString("Encounter", encounterId),
    subject: joinReferenceString("Patient", clientId),
  });

  const questionnaireResponsesById = new Map<string, QuestionnaireResponse>();
  for (const questionnaireResponse of questionnaireResponses) {
    if (questionnaireResponse.id) {
      questionnaireResponsesById.set(questionnaireResponse.id, questionnaireResponse);
    }
  }

  return questionnaireResponsesById;
}
